import React from 'react'

export const WeekViewGlobalContext = React.createContext()
